import React, { ReactNode } from "react";

import {
  EntityType,
  EntityTypeSupportingSourceTracking,
} from "@mapmycustomers/shared/types/entity";

import Path from "@app/enum/Path";
import { ClassName } from "@app/types/ui/ClassName";

import ModernLink from "./ModernLink";

interface BaseProps extends ClassName {
  children: ReactNode;
}

export const ViewAllLinkMap: Record<EntityTypeSupportingSourceTracking, React.FC<BaseProps>> = {
  [EntityType.ACTIVITY]: ({ children, ...props }: BaseProps) => (
    <ModernLink path={`${Path.ACTIVITY}/list`} {...props}>
      {children}
    </ModernLink>
  ),
  [EntityType.COMPANY]: ({ children, ...props }: BaseProps) => (
    <ModernLink path={Path.COMPANY} {...props}>
      {children}
    </ModernLink>
  ),
  [EntityType.DEAL]: ({ children, ...props }: BaseProps) => (
    <ModernLink path={Path.DEAL} {...props}>
      {children}
    </ModernLink>
  ),
  [EntityType.PERSON]: ({ children, ...props }: BaseProps) => (
    <ModernLink path={Path.PEOPLE} {...props}>
      {children}
    </ModernLink>
  ),
};
